import type { SubCondition } from './HubOptionState.types';
import { ConditionQuantifier } from './HubOptionState.types';

export type TextDestCondition = {
  uuid: string;
  quantifier: ConditionQuantifier;
  subConditions: SubCondition[];
  /** Override title text. Null = no override (use default). */
  resultText: string | null;
  /** Override destination. Null = no override (use default). */
  resultGotoBranchId: number | null;
};

export const HUB_MAX_TEXT_DEST_CONDITIONS = 5;
